import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, DataTable } from "../../../components";
import { Paper } from "@mui/material";
import {
  FormatListBulletedOutlined,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
  QuestionAnswerOutlined,
} from "@mui/icons-material";
import ButtonComponent from "../../../components/ButtonComponent";
import * as types from "../../../store/types/modalidades";
import Loading from "../../../components/Loading";
import {
  loadModalidades,
  loadModalidadesPorId,
} from "../../../store/actions/modalidades";
import ModalAdd from "./cadastro/add";
import { useParams } from "react-router-dom";
import CategoriasSecundarias from "./categoria_secundaria";

function QuestionarioModalidadesApp() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    modalidades_selecionada,
    modalidade_selecionada_page,
    modalidade_selecionada_per_page,
    modalidade_selecionada_total,
  } = useSelector((state) => state.modalidades);
  const [filtro, setFiltro] = useState("");
  const [filtroAtualizado, setFiltroAtualizado] = useState("");
  const [openModalCatSecundaria, modalCategoriasSecundarias] = useState(false);
  const [modalOpenAdd, setModalOpenAdd] = useState(false);
  const [dataModalInformations, setDataModalInformations] = useState({});
  const [loading, setLoading] = useState(false);

  async function GetDataLoad() {
    setLoading(true);
    const data = {
      page: modalidade_selecionada_page,
      per_page: modalidade_selecionada_per_page,
      filtro: filtroAtualizado,
      modalidade_id: id,
      status: "A",
    };
    await loadModalidadesPorId(data);
    setLoading(false);

    setFiltroAtualizado(""); // Limpa o estado após a requisição
  }

  const navigatePages = (validations) => {
    dispatch({
      type: types.MODALIDADE_SELECIONADA_DATA_PAGE,
      payload: validations,
    });
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (filtro === "") {
        GetDataLoad(); // Se filtro está vazio, chama a função GetDataLoad diretamente
      } else {
        setFiltroAtualizado(filtro);
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [filtro, modalidade_selecionada_page]);

  useEffect(() => {
    if (filtroAtualizado !== "") {
      GetDataLoad();
    }
  }, [filtroAtualizado, modalidade_selecionada_page]);



  const styledBtnArrows = {
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    border: "none",
    cursor: "pointer",
    margin: 15,
    backgroundColor: "transparent",
    fontFamily: "Poppins",
  };

  const columns = [
    { title: "Id", render: ({ id }) => id },
    {
      title: "Categorias principal",
      render: ({ categoria_principal }) => categoria_principal,
    },
    {
      title: "Categorias secundárias",
      render: (data) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flexDirection: "row",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <h5 style={{ marginRight: 10 }}>Ver categorias</h5>
            <FormatListBulletedOutlined fontSize="12px" />
          </div>
        );
      },
    },
  ];

  const handleRowClick = (event, rowData) => {
    console.log(rowData);
    setDataModalInformations(rowData);
    modalCategoriasSecundarias(true);
  };

  return (
    <div>
      <Loading loading={loading} />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <h4>Modalidades de atendimento</h4>
        <ButtonComponent onClick={() => setModalOpenAdd(true)}>
          Adicionar categoria
        </ButtonComponent>
      </div>
      <Paper elevation={1} style={{ padding: 5 }}>
        <DataTable
          columns={columns}
          data={modalidades_selecionada}
          enableHover={true}
          options={{
            defaultMessage: "Não há registros para serem exibidos.",
            rowStyle: { backgroundColor: "#ffffff", cursor: "pointer" },
            cellStyle: { border: "1px solid #ddd" },
          }}
          onRowClick={handleRowClick}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignContent: "center",
            alignItems: "center",
            fontFamily: "Poppins",
            fontSize: 14,
            justifyContent: "flex-end",
            marginBottom: 50,
          }}
        >
          <div
            style={{ marginRight: 30, display: "flex", flexDirection: "row" }}
          >
            {+modalidade_selecionada_page !== 1 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+modalidade_selecionada_page - 1)}
              >
                <KeyboardArrowLeftOutlined /> Anterior{" "}
              </button>
            )}

            {modalidades_selecionada?.length !== 0 && (
              <button
                style={styledBtnArrows}
                onClick={() => navigatePages(+modalidade_selecionada_page + 1)}
              >
                Próximo <KeyboardArrowRightOutlined />
              </button>
            )}
          </div>
          <p>
            Pagina <b>{modalidade_selecionada_page}</b> | Total de registros{" "}
            <b>{modalidade_selecionada_total}</b>
          </p>
        </div>
      </Paper>

      <ModalAdd
        open={modalOpenAdd}
        close={() => setModalOpenAdd(false)}
        updateList={() => GetDataLoad()}
        modalidade_id={id}
      />

      <CategoriasSecundarias
        open={openModalCatSecundaria}
        data={dataModalInformations}
        close={() => modalCategoriasSecundarias(false)}
      />
    </div>
  );
}

export default QuestionarioModalidadesApp;
